<div class="grid content-height  copytitle-fixed">
  <div class="bg-default pb-3">
    <div class="flex justify-content-between align-items-center title-bg">
      <h1 class="title justify-content-start"><i class="pi pi-star-fill" style="font-size: 1rem"></i>
        Copyright Notice Issue?</h1>
    </div>
    <div class="copyright-body pl-3 pr-3">
      <p>Though I’m quick to remind everyone that you don’t need to have a copyright symbol or any kind of notice on
        your work for it to be copyright protected, at least not since 1978 in the U.S., having a copyright footer on
        your site is probably a good idea just because of the large amount of confusion on this issue and it does put
        potential infringers on notice, reducing “innocent infringer” claims.</p>
    </div>
  </div>
  <div class="bg-default pb-3">
    <div class="flex justify-content-between align-items-center title-bg">
      <h1 class="title justify-content-start"><i class="pi pi-star-fill" style="font-size: 1rem"></i>
        Copyright Notice Issue?</h1>
    </div>
    <div class="copyright-body pl-3 pr-3">
      <p>Though I’m quick to remind everyone that you don’t need to have a copyright symbol or any kind of notice on
        your work for it to be copyright protected, at least not since 1978 in the U.S., having a copyright footer on
        your site is probably a good idea just because of the large amount of confusion on this issue and it does put
        potential infringers on notice, reducing “innocent infringer” claims.</p>
    </div>
  </div>
  <div class="bg-default pb-3">
    <div class="flex justify-content-between align-items-center title-bg">
      <h1 class="title justify-content-start"><i class="pi pi-star-fill" style="font-size: 1rem"></i>
        Copyright Notice Issue?</h1>
    </div>
    <div class="copyright-body pl-3 pr-3">
      <p>Though I’m quick to remind everyone that you don’t need to have a copyright symbol or any kind of notice on
        your work for it to be copyright protected, at least not since 1978 in the U.S., having a copyright footer on
        your site is probably a good idea just because of the large amount of confusion on this issue and it does put
        potential infringers on notice, reducing “innocent infringer” claims.</p>
    </div>
  </div>
  <div class="bg-default pb-3">
    <div class="flex justify-content-between align-items-center title-bg">
      <h1 class="title justify-content-start"><i class="pi pi-star-fill" style="font-size: 1rem"></i>
        Copyright Notice Issue?</h1>
    </div>
    <div class="copyright-body pl-3 pr-3">
      <p>Though I’m quick to remind everyone that you don’t need to have a copyright symbol or any kind of notice on
        your work for it to be copyright protected, at least not since 1978 in the U.S., having a copyright footer on
        your site is probably a good idea just because of the large amount of confusion on this issue and it does put
        potential infringers on notice, reducing “innocent infringer” claims.</p>
    </div>
  </div>
  <div class="bg-default pb-3">
    <div class="flex justify-content-between align-items-center title-bg">
      <h1 class="title justify-content-start"><i class="pi pi-star-fill" style="font-size: 1rem"></i>
        Copyright Notice Issue?</h1>
    </div>
    <div class="copyright-body pl-3 pr-3">
      <p>Though I’m quick to remind everyone that you don’t need to have a copyright symbol or any kind of notice on
        your work for it to be copyright protected, at least not since 1978 in the U.S., having a copyright footer on
        your site is probably a good idea just because of the large amount of confusion on this issue and it does put
        potential infringers on notice, reducing “innocent infringer” claims.</p>
    </div>
  </div>
</div>
